import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';

export default class UnknownCustomerDialog extends Component {

  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    title: PropTypes.string,
    message: PropTypes.node,
  };

  static defaultProps = {
    open: false,
    onClose: () => {},
    title: "Numéro Inconnu",
    message: null,
  };

  actions = [
    <FlatButton
      label="OK"
      primary={true}
      keyboardFocused={true}
      onClick={this.props.onClose}
    />,
  ];

  render() {
    return (
      <Dialog
        title={this.props.title}
        actions={this.actions}
        modal={true}
        open={this.props.open}
        onRequestClose={this.props.onClose}
      >
        Désolé,<br /><br />
        {this.props.message || "Vous devez déjà être client pour pouvoir prendre rendez-vous en ligne."}
      </Dialog>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/UnknownCustomerDialog.js